<div
  class="mt-2"
  #codemirror
></div>
<p-table [value]="this.detectedErrors">
  <ng-template
    pTemplate="body"
    let-errorLine
    >
    <tr>
      <td style="text-align: right; vertical-align: top;">{{ errorLine.line }}:</td>
      <td style="padding-left: 0.5rem;">
        @for (error of errorLine.errors; track $index) {
          <span>
            @if (error.code==='W030') {
              <i class="ri-file-damage-fill text-danger"></i>
            }
            @if (error.code!=='W030') {
              <i class="ri-alert-fill text-warning"></i>
            }
            {{ error.reason }}
          </span><br>
        }
      </td>
    </tr>
  </ng-template>
</p-table>